import { render, staticRenderFns } from "./Featured.vue?vue&type=template&id=86cd4f0a&scoped=true"
import script from "./Featured.vue?vue&type=script&lang=js"
export * from "./Featured.vue?vue&type=script&lang=js"
import style0 from "./Featured.vue?vue&type=style&index=0&id=86cd4f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cd4f0a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogPreview: require('/home/rohit/Documents/GitHub/aibuddha-website/components/blog/Preview.vue').default})
